import { company, navLinks } from "../mock";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import logoFull from "../assets/logo-full.png";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="inline-flex items-center bg-white rounded-xl px-4 py-3">
              <img
                src={logoFull}
                alt="Selekto Sähköpalvelu"
                className="h-11 w-auto object-contain"
              />
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              {company.slogan}. Toteutamme ja kehitämme sähköpalveluja asiakkaan
              eduksi yhteistyössä sähköalan toimijoiden kanssa.
            </p>
            <a
              href={company.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Selekto Facebookissa"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#1877F2] hover:bg-[#0e5fd8] text-white px-4 py-2 text-sm font-semibold transition-colors shadow-lg shadow-[#1877F2]/30"
            >
              <Facebook className="w-4 h-4" fill="currentColor" />
              Seuraa Facebookissa
            </a>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider">
              Sivut
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider">
              Yhteystiedot
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary" />
                <a href={`tel:${company.phoneRaw}`} className="hover:text-primary transition-colors">
                  {company.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary" />
                <a href={`mailto:${company.email}`} className="hover:text-primary transition-colors">
                  {company.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                <a
                  href={company.mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  {company.address}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {company.name} {company.tagline} · Y-tunnus {company.ytunnus}
          </p>
          <p className="text-xs text-slate-500">{company.contactPerson.name}</p>
        </div>
      </div>
    </footer>
  );
}
